import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {DcpTenantKey} from '@app/checkout/services/dcp-entitlement.service';
import {DefaultModalService} from '../modal/services/default-modal.service';
import {TranslationService} from '@spartacus/core';
import {first} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-deployment-systems',
  templateUrl: './deployment-systems.component.html',
  styleUrls: ['./deployment-systems.component.scss']
})
export class DeploymentSystemsComponent<T> {
  @Input() header: string;
  @Input() description: string;
  @Input() items: T[];
  @Input() tenantKeys: DcpTenantKey[];
  @ViewChild('modalContentTemplate') modalContentTemplate: TemplateRef<any>;
  modalTitleKey: string = 'configurator.deploymentSystems.system_plural';
  modalTitleValue: string;
  modalId: string;
  
  constructor(private modalService: DefaultModalService,
    private translationService: TranslationService) {}

  openModal() {
    this.translationService.translate(this.modalTitleKey)
    .pipe(first(), untilDestroyed(this))
    .subscribe((translation) => {
      this.modalTitleValue = translation;
  });
    this.modalId = this.modalService.openModal(this.modalContentTemplate, this.modalTitleValue);
  }

  closeModal() {
    this.modalService.closeModal(this.modalId);
  }
}
